import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Card from "@mui/material/Card";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid";
import config from '../../../../config';
import BarTimeValue from '../Charts/BarTimeValue';
import { namedColor, transparentize } from 'Chart/ChartUtils';
import { detectorNames } from 'modules/globals';
import { DIAGRAM_COLORS } from 'diagrammColors';

const SpeedTravelNetwork = ({params}) => {
    const { t } = useTranslation();

    const [chartData, setChartData] = useState()
    const [error, setError] = useState(false)
    const [noRouteData, setNoRouteData] = useState(false)

    useEffect(() => {
        async function fetchData() {
            try {
                let getUrl = "";
                let header = "open_imet";
                if (params.detector === "tomtomfcd") {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_tomtom_completeness_per_network?start_ts=${params.dates.from}&end_ts=${params.dates.to}`
                    header = "route_monitoring";
                } else if (params.detector === "taxifcd") {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_taxi_completeness_per_network?start_time=${params.dates.from}&end_time=${params.dates.to}`
                } else {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_bt_completeness_per_network?start_time=${params.dates.from}&end_time=${params.dates.to}`
                }
                const response = await axios(getUrl, {
                    headers: {
                        "Accept-Profile": header
                    }
                });
                if (!response.data) {
                    setNoRouteData(true)
                } else {
                    setNoRouteData(false);
                    let data;
                    if (params.detector === "tomtomfcd") {
                        data = response.data.map((item) => ({
                            x: new Date(item.ts).toLocaleString('en-GB'), // Format date to be readable
                            y: item.completeness,
                        }));
                    } else if (params.detector === "taxifcd") {
                        data = response.data.map((item) => ({
                            x: new Date(item.ts).toLocaleString('en-GB'), // Format date to be readable
                            y: item.completeness,
                        }));
                    } else {
                        data = response.data.map((item) => ({
                            x: new Date(item.ts).toLocaleString('en-GB'), // Format date to be readable
                            y: item.completeness,
                        }));
                    }
                    const chartD = {
                        datasets: [
                            {
                                label: t("dataQuality.speedTravelNetwork.networkLabel", { vendor: detectorNames[params.detector] }),
                                data: data,
                                backgroundColor: DIAGRAM_COLORS[0],
                                borderWidth: 0, // Removes the connecting line                            
                                tension: 0.4, // Line smoothing
                                minBarLength: 7, // Ensures bars are visible even when value is 0
                            }
                        ]
                    };
                    setChartData(chartD);
                }
            } catch (error) {
                console.log(error)
            }
        }
        fetchData();
    }, [params])




    return (
        <Card style={{ marginTop: '3px', padding: '12px', height: '100%' }}>
            <Grid container item xs={12} md={12}>
                <Grid container={true} p={2}>
                    {
                        (params.location === "Network") &&
                        <div className='rawContainerDiagrams'>
                            <div className='diagrammHeadTitle'>{t("dataQuality.metrics.completeness")} {detectorNames[params.detector]}</div>
                            {chartData ? <div className='detectorDiagramsContainer'><BarTimeValue chartData={chartData} title="" /></div> : <div className='rawContainerCenteredH'><CircularProgress /></div>}
                        </div>
                    }
                </Grid>
            </Grid>
        </Card>
    );
};

export default SpeedTravelNetwork;